// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaGoogle_root__5A0qS"};